<template>
  <main class="p-5">
    <p class="info">
      Please scan this QR code with your mobile phone to select your preferences
      and download your digital voucher pass.
    </p>
    <div
      style="justify-content: center;
    display: flex;"
    >
      <VueQrcode :value="url" :options="{ width: 200 }" />
    </div>
  </main>
</template>

<script>
import VueQrcode from "@chenfengyuan/vue-qrcode";

export default {
  components: {
    VueQrcode
  },

  data: () => {
    return { url: window.location };
  }
};
</script>
<style scoped>
.info {
  text-align: center;
  max-width: 600px;
  margin: 0 auto;
  margin-bottom: 60px;
}
</style>
